import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight, X } from "lucide-react";

const IMAGES = [
  // Tarzan Hyderabad Retreat (actual property photos)
  "https://lh3.googleusercontent.com/d/1JASTJqPCY0RbtIztaCx8eRP4_8tnl8nF=w1800",
  "https://lh3.googleusercontent.com/d/1qGgy9kngs99pFbUGcZJo4jRfpiQ87aBb=w1800",
  "https://lh3.googleusercontent.com/d/1o8zdrsUfIm-SiNlsfOtVfHW8nGdRclz4=w1800",
  "https://lh3.googleusercontent.com/d/1APIY5ZfPfRAMPLTnmcRJt2hZPFl1lK22=w1800",
  "https://lh3.googleusercontent.com/d/1hubFWXDNIYIGRc3SKtelOzpAZPYIu0ln=w1800",
  "https://lh3.googleusercontent.com/d/1sIna_vLkrzACdkDQC5IY5hCV0Kh3en5T=w1800",
  "https://lh3.googleusercontent.com/d/1YgomR_JGWqXNxpJd9LNrfYjMnvnCRSUj=w1800",
  "https://lh3.googleusercontent.com/d/12kDzqIAp5bqUQ4Cu2qBTySrIBRRX9Pl6=w1800",
  "https://lh3.googleusercontent.com/d/1SCqfh4-sPkDVTCnhXTdSP3PY9L9GMw8A=w1800",
  "https://lh3.googleusercontent.com/d/1oyxinHASQLUi_A_x14ARf7WJkem-KQGN=w1800",
  "https://lh3.googleusercontent.com/d/1CNGBrLR0epVIEKOsip0DeK48Ee7cWI31=w1800",
  "https://lh3.googleusercontent.com/d/1BabDDXwPRvpWa-_stMy82G3-zfnRR5ts=w1800",
  "https://lh3.googleusercontent.com/d/12lqH15JxHxnrYkgJydIIT6Ez5q-LyALr=w1800",
  // Community
  "https://lh3.googleusercontent.com/d/15o0aiHe3XO-R-Qe-QZMrIB1WlxTBD_9A=w1800",
  "https://lh3.googleusercontent.com/d/1W5bd9I-peA1ZyOsk1ZQEk52cRJcNM2rL=w1800",
  "https://lh3.googleusercontent.com/d/1mxRCSg25BWwOqoclwHL2ufP45I94FS7s=w1800",
  "https://lh3.googleusercontent.com/d/1sxH9v-b_Tc0HB1MZ1MUYgf3_zIyR7h45=w1800",
  // Farmstay
  "https://lh3.googleusercontent.com/d/1aqwimeRWVRvBrO0K0z2B3jYJradfoyMY=w1800",
  "https://lh3.googleusercontent.com/d/1ELduEHdzKI4fe8eayE0Kc3hlymJyHtBc=w1800",
  "https://lh3.googleusercontent.com/d/1v2FrLk41BCN-LBOiCXs4cGC-pxcurD5S=w1800",
  // Villa
  "https://lh3.googleusercontent.com/d/1vZVBrym_Gjxc_Jh2XZWDuG4ilkezTaEM=w1800",
  "https://lh3.googleusercontent.com/d/1pECItp5h_wGorLAAE8ke1_JpILbqRIW3=w1800",
  "https://lh3.googleusercontent.com/d/1Jz2xHq127g2LtC7s-dObbx5W4JkGZhKN=w1800",
  "https://lh3.googleusercontent.com/d/1_TJKPoQ5YWnOt8L4S4SFqUkvcGzdsTeT=w1800",
  // Village
  "https://lh3.googleusercontent.com/d/1JPd3BLPd_sm-G24ZAHMP3WcjcEDAs2yY=w1800",
  "https://lh3.googleusercontent.com/d/1EO8v8xr3-llQ4QwwKVOSJZrNfrL1oq7p=w1800",
  "https://lh3.googleusercontent.com/d/12X5y49BreUAjm0dH2ZIpajvR1wtwk_-A=w1800",
  "https://lh3.googleusercontent.com/d/1sduH3nC8ZpYHxUhfMD7pa4Y5hUMsGBXj=w1800",
];

// span-classes so certain images take more space – editorial mosaic
const SPAN = ["md:col-span-2 md:row-span-2", "", "", "md:col-span-2", "", "md:row-span-2", "", "md:col-span-2 md:row-span-2", "", "md:col-span-2", "", "", "md:row-span-2", "md:col-span-2", "", "", "", "", "", "md:col-span-2", "", "", "md:row-span-2", "", "", "", "md:col-span-2", "", ""];

export default function Gallery() {
  const [openIdx, setOpenIdx] = useState(null);
  const isOpen = openIdx !== null;
  const next = (e) => { e?.stopPropagation(); setOpenIdx((openIdx + 1) % IMAGES.length); };
  const prev = (e) => { e?.stopPropagation(); setOpenIdx((openIdx - 1 + IMAGES.length) % IMAGES.length); };

  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e) => {
      if (e.key === "Escape") setOpenIdx(null);
      else if (e.key === "ArrowRight") next();
      else if (e.key === "ArrowLeft") prev();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
    // eslint-disable-next-line
  }, [openIdx, isOpen]);

  return (
    <div className="bg-ivory pt-28 pb-24 min-h-screen">
      <div className="container-tarzan">
        <div className="max-w-2xl">
          <div className="eyebrow mb-3">Gallery</div>
          <h1 className="font-serif text-5xl md:text-6xl text-ink tracking-tight leading-[1.02]">A visual feast<br/><em className="not-italic text-forest">from the wild.</em></h1>
          <p className="text-ink-soft mt-5 text-base md:text-lg leading-relaxed">A window into every corner of the Tarzan world — the light, the mist, the food and the mornings that stay with our guests forever.</p>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 auto-rows-[180px] md:auto-rows-[220px] gap-3 md:gap-4">
          {IMAGES.map((src, i) => (
            <button
              key={i}
              onClick={() => setOpenIdx(i)}
              className={`relative overflow-hidden rounded-2xl group ${SPAN[i] || ""}`}
              data-testid={`gallery-img-${i}`}
            >
              <img src={src} alt="" loading="lazy" className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1200ms]" />
              <div className="absolute inset-0 bg-forest-900/0 group-hover:bg-forest-900/20 transition-colors" />
            </button>
          ))}
        </div>
      </div>

      {isOpen && (
        <div onClick={() => setOpenIdx(null)} className="fixed inset-0 z-[70] bg-forest-900/95 grid place-items-center p-6 backdrop-blur" data-testid="gallery-lightbox">
          <button onClick={(e)=>{e.stopPropagation(); setOpenIdx(null);}} data-testid="lightbox-close" className="absolute top-5 right-5 h-11 w-11 rounded-full bg-ivory/10 border border-ivory/25 grid place-items-center text-ivory hover:bg-ivory hover:text-forest-900 transition-colors z-10"><X className="h-5 w-5" /></button>
          <button onClick={prev} data-testid="lightbox-prev" aria-label="Previous" className="absolute left-4 md:left-8 top-1/2 -translate-y-1/2 h-12 w-12 md:h-14 md:w-14 rounded-full bg-ivory/10 border border-ivory/25 grid place-items-center text-ivory hover:bg-ivory hover:text-forest-900 transition-colors"><ChevronLeft className="h-6 w-6" /></button>
          <button onClick={next} data-testid="lightbox-next" aria-label="Next" className="absolute right-4 md:right-8 top-1/2 -translate-y-1/2 h-12 w-12 md:h-14 md:w-14 rounded-full bg-ivory/10 border border-ivory/25 grid place-items-center text-ivory hover:bg-ivory hover:text-forest-900 transition-colors"><ChevronRight className="h-6 w-6" /></button>
          <img src={IMAGES[openIdx]} alt="" onClick={(e)=>e.stopPropagation()} className="max-w-[92vw] max-h-[85vh] rounded-2xl luxe-shadow object-contain" />
          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-ivory/70 text-xs tracking-[0.22em] uppercase">{openIdx + 1} / {IMAGES.length}</div>
        </div>
      )}
    </div>
  );
}
